import { render } from "./SideBarCard.vue?vue&type=template&id=70d72008"
import script from "./SideBarCard.vue?vue&type=script&lang=js"
export * from "./SideBarCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__